
import { Tabs, Button } from "antd";

import AppLayout from "../../components/Layout";
import { PhonebookTable } from "../../components/Dashboards/Tables/PhonebookTable";
import { SolveesyDiallerTable } from "./SolveesyDiallerTable";
import  CampaignReport from "./Campaign/campaign";

const SolveesyDialler = () => {
  const items = [
    {
      label: "Phonebook",
      key: "1",
      children: <SolveesyDiallerTable  />,
    },
       {
      label: "Campaigns",
      key: "2",
      children: <CampaignReport  />,
    },
  ];

  return (

      <Tabs items={items}></Tabs>
  
  );
};

export default SolveesyDialler;
